/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Ateliere_Connect_Import_FailedInputs */

const en_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project Import Failed. ${i?.message}`)
};

const fr_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’importation du projet. ${i?.message}`)
};

const de_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projektimport fehlgeschlagen. ${i?.message}`)
};

const it_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione del progetto non riuscita. ${i?.message}`)
};

const ru_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импорт проекта не удался. ${i?.message}`)
};

const es_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la importación del proyecto. ${i?.message}`)
};

const zh_cn2_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目导入失败。${i?.message}`)
};

const ja_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポートに失敗しました。${i?.message}`)
};

const hi_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात विफल। ${i?.message}`)
};

const pt_pt2_ateliere_connect_import_failed = /** @type {(inputs: Ateliere_Connect_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A importação do projeto falhou. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Project Import Failed. {message}" |
*
* @param {Ateliere_Connect_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_import_failed = /** @type {((inputs: Ateliere_Connect_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_import_failed(inputs)
	if (locale === "de") return de_ateliere_connect_import_failed(inputs)
	if (locale === "it") return it_ateliere_connect_import_failed(inputs)
	if (locale === "ru") return ru_ateliere_connect_import_failed(inputs)
	if (locale === "es") return es_ateliere_connect_import_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_import_failed(inputs)
	if (locale === "ja") return ja_ateliere_connect_import_failed(inputs)
	if (locale === "hi") return hi_ateliere_connect_import_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_import_failed(inputs)
	return en_ateliere_connect_import_failed(inputs)
});